import PropTypes from 'prop-types';
import VaccinesOutlinedIcon from '@mui/icons-material/VaccinesOutlined';
import DateRangeReportCard from './DateRangeReportCard';
import {
    downloadMedicineDispenseReport,
    downloadMedicineDispenseXlsxReport
} from '../../../../api/services/filesService';

function MedicineDispenseCard({groupFilters}) {
    return (
        <DateRangeReportCard
            testId="medicine-dispense-report"
            icon={<VaccinesOutlinedIcon sx={{fontSize: 48, mb: 2, color: '#155FA7'}}/>}
            title="Medicine at School Report"
            groupFilters={groupFilters}
            downloadCsv={downloadMedicineDispenseReport}
            downloadXlsx={downloadMedicineDispenseXlsxReport}
        />
    );
}

MedicineDispenseCard.propTypes = {
    groupFilters: PropTypes.array
};

export default MedicineDispenseCard;
